
import { MoreVert } from "@mui/icons-material";
import { useState } from "react";
import { useShipments } from "../../hooks/useShipments";
import { Shipment } from "@domain/shipment";
import { IconButton, Stack } from "@mui/material";
import { Menu, MenuItem, Typography, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@mui/material";
import { useGenericDrawer } from "@shared/shell/drawer/useGenericDrawer";
import { useBottomSheet } from "@shared/shell/bottomsheet/useBottomSheet";
import { EditShipmentDetails } from "../edit/EditShipmentDetails";

interface ShipmentActionsProps {
    shipment: Shipment;
}

const ShipmentActions: React.FC<ShipmentActionsProps> = ({ shipment }) => {

    const { closeDrawer } = useGenericDrawer();
    const { openBottomSheet, closeBottomSheet } = useBottomSheet();

    const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);
    const [menuOpen, setMenuOpen] = useState(false);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

    const { deleteShipment, isDeleting } = useShipments();

    const handleDeleteClick = () => {
        setDeleteDialogOpen(true);
    }

    const handleDeleteConfirm = async () => {
        try {
            await deleteShipment(shipment.id!);
            setDeleteDialogOpen(false);
            setMenuOpen(false);
            closeDrawer();
        } catch (error) {
            console.error('Failed to delete shipment:', error);
        }
    };

    const handleDeleteCancel = () => {
        setDeleteDialogOpen(false);
        setMenuOpen(false);
    };

    const handleEditClick = () => {
        setMenuOpen(false);
        openBottomSheet({
            title: 'Edit Shipment',
            component: <EditShipmentDetails
                shipmentId={shipment.id!}
                onFinish={() => closeBottomSheet()}
                onClose={() => closeBottomSheet()}
            />,
            closeOnBackdropClick: true
        });
    };

    return (
        <>
            <Stack direction="row" spacing={1}>

                <IconButton onClick={(e) => {
                    setMenuAnchorEl(e.currentTarget);
                    setMenuOpen(true);
                }}>
                    <MoreVert />
                </IconButton>
            </Stack>

            <Menu
                open={menuOpen}
                onClose={() => setMenuOpen(false)}
                anchorEl={menuAnchorEl}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                }}
            >

                <MenuItem onClick={() => handleEditClick()}>
                    <Typography variant="subtitle2">
                        Edit shipment
                    </Typography>
                </MenuItem>
                <MenuItem onClick={() => handleDeleteClick()} color="error">
                    <Typography variant="subtitle2" color="error">
                        Delete shipment
                    </Typography>
                </MenuItem>
            </Menu>

            {/* Delete Shipment Confirmation Dialog */}
            <Dialog
                open={deleteDialogOpen}
                onClose={handleDeleteCancel}
                aria-labelledby="delete-shipment-dialog-title"
                aria-describedby="delete-shipment-dialog-description"
            >
                <DialogTitle id="delete-shipment-dialog-title">
                    Delete Shipment
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="delete-shipment-dialog-description">
                        Are you sure you want to delete the shipment "{shipment.name}"? This action cannot be undone.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDeleteCancel} disabled={isDeleting}>
                        Cancel
                    </Button>
                    <Button
                        onClick={handleDeleteConfirm}
                        color="error"
                        variant="contained"
                        disabled={isDeleting}
                    >
                        {isDeleting ? 'Deleting...' : 'Delete'}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default ShipmentActions;